export const STYLIE_AWARDS_FLAG_NAME = 'stylie_awards_com1197_20230622';
export const STYLIES_LOCALSTORAGE_CACHE_KEY = 'stylies_info';
